import Swiper from 'swiper/bundle'

const $ = jQuery

export default function Articles () {
  const WRAPPERS = document.querySelectorAll('.mtt-articles')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = new ArticleWrapper(WRAPPERS[i])
      WRAPPER.init()
    }
  }
}

class ArticleWrapper {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.CATEGORIES = this.WRAPPER.querySelectorAll('.mtt-articles__category')
    this.LEFT_ARROW = this.WRAPPER.querySelector('.swiper-button-prev')
    this.RIGHT_ARROW = this.WRAPPER.querySelector('.swiper-button-next')
    this.LOADER = this.WRAPPER.querySelector('.mtt-articles__loader')
    this.TARGET = this.WRAPPER.querySelector('.mtt-articles__target')
    this.PAGINATION_TARGET = this.WRAPPER.querySelector('.mtt-articles__pagination-target')

    this.type = this.WRAPPER.getAttribute('data-type')
    this.url = this.WRAPPER.getAttribute('data-url')
    this.activeCat = null

    this.data = {
      action: this.type !== null ? `filter_articles_${this.type}` : 'filter_articles',
      category: this.WRAPPER.getAttribute('data-initial-category') || 0,
      pagenumber: 1,
      actualCategory: 0
    }
  }

  init () {
    this.createSwiper()
    this.categoriesHandler()
    this.paginationHandler()
  }

  createSwiper () {
    const SWIPER_CONTAINER = this.WRAPPER.querySelector('.swiper-container')
    if (SWIPER_CONTAINER) {
      const SWIPER = new Swiper(SWIPER_CONTAINER, {
        init: false,
        slidesPerView: 1.1,
        speed: 800,
        spaceBetween: 24,
        watchOverflow: true,
        navigation: {
          nextEl: this.RIGHT_ARROW,
          prevEl: this.LEFT_ARROW
        },
        breakpoints: {
          501: { slidesPerView: 1.5 },
          651: { slidesPerView: 2 },
          801: { slidesPerView: 2.5 },
          1001: { slidesPerView: 3 }
        }
      })

      SWIPER.init()
    }
  }

  categoriesHandler () {
    if (this.CATEGORIES.length > 0) {
      for (let i = 0; i < this.CATEGORIES.length; i++) {
        const CAT = this.CATEGORIES[i]

        CAT.addEventListener('click', () => {
          this.data.category = this.data.actualCategory = CAT.getAttribute('data-category')
          const actualCat = CAT.getAttribute('data-actual-category')
          if (actualCat) this.data.actualCategory = actualCat
          this.data.pagenumber = 1
          this.loadPosts()
          this.type === 'archive' && this.buildUrl()
        })
      }
    }
  }

  paginationHandler () {
    const PAGINATION_TOGGLES = this.WRAPPER.querySelectorAll('.mtt-pagination__toggle')
    if (PAGINATION_TOGGLES.length > 0) {
      for (let i = 0; i < PAGINATION_TOGGLES.length; i++) {
        const TOGGLE = PAGINATION_TOGGLES[i]

        TOGGLE.addEventListener('click', (e) => {
          e.preventDefault()
          this.data.pagenumber = TOGGLE.getAttribute('data-page')
          this.loadPosts()
          this.type === 'archive' && this.buildUrl()
        })
      }
    }
  }

  setActiveCategory () {
    for (let i = 0; i < this.CATEGORIES.length; i++) {
      const CAT = this.CATEGORIES[i]
      CAT.getAttribute('data-category') === this.data.category
        ? CAT.classList.add('active')
        : CAT.classList.remove('active')
    }
  }

  loadPosts () {
    this.beforeAjax()
    $.post(main_theme_objects.ajax_url, this.data,
      (response) => {
        if (response !== 0) {
          if (this.TARGET && 'markup' in response) this.TARGET.innerHTML = response.markup
          if (this.PAGINATION_TARGET && 'pagination' in response) this.PAGINATION_TARGET.innerHTML = response.pagination
          this.paginationHandler()
          this.afterAjax()
        }
      }
    )
  }

  beforeAjax () {
    this.showLoader()
    this.setActiveCategory()
  }

  afterAjax () {
    this.hideLoader()
    this.createSwiper()
    this.scrollTop()
  }

  showLoader () {
    this.LOADER && this.LOADER.classList.add('loader--show')
  }

  hideLoader () {
    this.LOADER && this.LOADER.classList.remove('loader--show')
  }

  buildUrl () {
    let parametersString = this.url
    const parameters = []

    // add pagenumber
    if ('pagenumber' in this.data && parseInt(this.data.pagenumber) > 1) {
      parametersString += `page/${this.data.pagenumber}/`
    }

    // add cat
    if ('category' in this.data && parseInt(this.data.category) !== 0) {
      parameters.push(`category=${this.data.category}`)
    }

    if (parameters.length > 0) {
      for (let i = 0; i < parameters.length; i++) {
        parametersString += i === 0 ? '?' : '&'
        parametersString += parameters[i]
      }
    }

    window.history.pushState(`articles_${this.type}`, '', parametersString)
  }

  getScrollOffset () {
    let offset = 0
    const HEADER = document.getElementById('main_header')
    offset += HEADER ? HEADER.getBoundingClientRect().height : 0
    const ADMIN_BAR = document.getElementById('wpadminbar')
    offset += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0
    return offset
  }

  scrollTop () {
    $('html, body').animate({
      scrollTop: $(this.WRAPPER).offset().top - this.getScrollOffset()
    }, 700)
  }
}
